"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _themeOptimized = _interopRequireDefault(require("../themeOptimized"));

var _root = _interopRequireDefault(require("./style/root"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _globals = require("../../globals.js");

var _passive = _interopRequireDefault(require("./style/passive"));

var _active = _interopRequireDefault(require("./style/active"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _extractStates = _interopRequireDefault(require("../style/extractStates"));

var Underscore = function Underscore(_ref) {
  var _ref$state = _ref.state,
      state = _ref$state === void 0 ? _globals.STATE.IDLE : _ref$state,
      style = _ref.style,
      theme = _ref.theme;
  var styles = (0, _react.useMemo)(function () {
    return (0, _extractStates["default"])((0, _mergeTheme["default"])(theme, style));
  }, [theme, style]);
  return _react["default"].createElement(_root["default"], null, _react["default"].createElement(_passive["default"], {
    state: state,
    theme: styles[_globals.STATE.IDLE]
  }), _react["default"].createElement(_active["default"], {
    theme: styles[state]
  }));
};

Underscore.propTypes = {
  state: _propTypes["default"].oneOf([_globals.STATE.IDLE, _globals.STATE.ERROR, _globals.STATE.HOVER, _globals.STATE.FOCUS, _globals.STATE.DISABLED]),
  theme: _propTypes["default"].object,
  style: _propTypes["default"].object
};

var _default = (0, _themeOptimized["default"])(Underscore, 'underscore');

exports["default"] = _default;